// @flow

import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import SubpageHeroTeaser from '../../../components/SubpageHeroTeaser'

import messages from './VacancyTeaser.lang'
import baseStyles from './VacancyTeaser.scss'
import { StaticImage } from 'gatsby-plugin-image'

const HeroTeaserImage = (
  <StaticImage
    src="../../../images/heroteaser/career_heroteaser_bg_desktop.jpg"
    alt=""
    objectFit="cover"
    className="image"
  />
)

type Props = {
  ...StyleProps,
  title: string
}

const VacancyTeaser = ({ title, styles }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <SubpageHeroTeaser
      title={title}
      titleLink="/career/"
      titleLinkLabel={formatMessage(messages.careerLink)}
      image={HeroTeaserImage}
      imgAlt="office gallery"
    />
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(VacancyTeaser)
